export default __webpack_public_path__ + "static/media/hero-mobile.3735c0fe.jpg";